<script>
  import CodeSnippet from '../components/CodeSnippet.svelte';

  const primaryButtonsSnippet = `
    <button class="button button-primary-light">Primary Light</button>
    <button class="button button-primary-dark">Primary Dark</button>
    <button class="button button-primary-light button-small">
      Small
    </button>
    <button class="button button-primary-light button-large">
      Large
    </button>
    <button class="button button-primary-light button-full-width">
      Full Width
    </button>
  `;

  const secondaryButtonSnippet = `
    <button class="button button-secondary-dark">Secondary Dark</button>
    <button class="button button-secondary-light">Secondary Light</button>
    <button class="button button-secondary-dark button-small">
      Small
    </button>
    <button class="button button-secondary-dark button-large">
      Large
    </button>
    <button class="button button-secondary-dark button-full-width">
      Full Width
    </button>
  `;
</script>

<template>
  <section id="button" class="page-section bg-warmWhite40">
    <div class="container">
      <h2 class="heading heading-2 my-6">Buttons</h2>
      <h3 class="heading heading-3 mt-8 mb-6">Primary</h3>
      <div class="space-y-4">
        <div>
          <button class="button button-primary-light">Primary Light</button>
          <button class="button button-primary-dark">Primary Dark</button>
        </div>
        <div>
          <button class="button button-primary-light button-small">Small</button>
          <button class="button button-primary-light button-large">Large</button>
        </div>
        <button class="button button-primary-light button-full-width">Full Width</button>
        <CodeSnippet id="primary-buttons" snippet={primaryButtonsSnippet} />
      </div>

      <h3 class="heading heading-3 mt-8 mb-6">Secondary</h3>
      <div class="space-y-4">
        <div>
          <button class="button button-secondary-dark">Secondary Dark</button>
          <button class="button button-secondary-light">Secondary Light</button>
        </div>
        <div>
          <button class="button button-secondary-dark button-small">Small</button>
          <button class="button button-secondary-dark button-large">Large</button>
        </div>
        <button class="button button-secondary-dark button-full-width">Full Width</button>
      </div>
      <CodeSnippet id="secondary-buttons" snippet={secondaryButtonSnippet} />
    </div>
  </section>
</template>
